export enum ETipoMovimientoCaja {
  INGRESO = 'INGRESO',
  EGRESO = 'EGRESO',
  VENTA = 'VENTA',
  DEVOLUCION = 'DEVOLUCION',
  ANULADO = 'ANULADO',
  VUELTO = 'VUELTO',
}
